<template>
  <div v-show="data.length > 0">
    <table class="mdl-data-table mdl-js-data-table full-width">
      <thead>
        <tr>
          <th v-if="selectable" class="column-check">
            <label id="select-all" class="mdl-checkbox mdl-js-checkbox">
              <input type="checkbox" class="mdl-checkbox__input"  v-on:click="selectAll">
            </label>
          </th>
          <th v-for="col in columns" class="mdl-data-table__cell--non-numeric">
            <div :class="{'iconized': col.observable}">
              <span v-if="filter.indexOf(col.value) === -1">{{ col.label  | label}}</span>
              <span v-show="col.observable" class="fas" :class="{'fa-eye': isFaEye, 'fa-eye-slash': isFaEyeSlash}"  @click="toggleShowEmail">&nbsp;</span>
              <div class="symbol" v-if="filter.indexOf(col.value) > -1">
                <div class="filter-textfield mdl-textfield mdl-js-textfield">
                  <input class="mdl-textfield__input" type="text" id="filter-{{col.value}}" placeholder="{{col.label | label}}" v-model="query[col.value]">
                </div>
                <i v-show="sorted.col !== col.value" class="material-icons filter-icon">search</i>
                <!-- <input class="filter-bar" type="text" v-model="query[col]" placeholder="{{ col }}"/> -->
              </div>
              <span class="symbol" v-if="sort.indexOf(col.value) > -1" v-on:click="doSort(col.value)">
                <i v-show="sorted.col === col.value && sorted.asc" class="material-icons">keyboard_arrow_up</i>
                <i v-show="sorted.col === col.value && !sorted.asc" class="material-icons">keyboard_arrow_down</i>
                <i v-show="sorted.col !== col.value" class="material-icons">keyboard_arrow_down</i>
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in filtered">
          <td v-if="selectable">
            <label id="select-{{row.id}}" class="mdl-checkbox mdl-js-checkbox">
              <input type="checkbox" class="mdl-checkbox__input"
                value={{row.id}}
                v-model="selected" >
            </label>
          </td>
          <td v-for="cell in columns" class="mdl-data-table__cell--non-numeric"
           v-on:click="$dispatch('table-clicked', row)" :class="{'hidetext': hideText && cell.observable}">{{ row[cell.value] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-show="data.length > 0" class="slot">
    <slot name="actions"></slot>
  </div>
  <div v-show="data.length === 0">
    <slot name="empty"></slot>
  </div>
</template>

<script>
module.exports = {
  ready: function () {
    var self = this
    window.componentHandler.upgradeAllRegistered()
    var columnsSource = this.columns || Object.keys(this.data[0])
    var observablesSource = (this.observables ? this.observables : [])
    columnsSource.forEach(function (col, idx) {
      if (!observablesSource[idx]) observablesSource[idx] = false
      else observablesSource[idx] = true
    })
    this.observables = observablesSource
    this.columns = columnsSource.filter(function (col) {
      return ['id', '__checked'].indexOf(col) === -1
    }).map(function (col) {
      return {
        value: col,
        label: self.page + '.tableColumn.' + col,
        observable: (self.observables[self.columns.indexOf(col)])
      }
    })
    this.filtered = this.data
  },
  props: {
    data: {
      type: Array,
      required: true,
      twoWay: true
    },
    page: String,
    selectable: Boolean,
    columns: Array,
    sort: Array,
    filter: Array,
    observables: Array
  },
  events: {
    'clear-select': function () {
      this.selected = []
      this.refreshChecks()
    }
  },
  methods: {
    selectAll: function () {
      if (this.selectedAll) {
        this.selected = []
      } else {
        this.selected = this.filtered.map(function (row) {
          return row.id
        })
      }
      this.refreshChecks()
    },
    doSort: function (col) {
      var asc = !this.sorted.asc
      this.sorted = {
        col: col,
        asc: asc
      }
      this.filtered = this.filtered.sort(function (a, b) {
        if (a[col] < b[col] && asc) return -1
        if (a[col] < b[col] && !asc) return 1
        if (a[col] > b[col] && asc) return 1
        if (a[col] > b[col] && !asc) return -1
        if (a[col] === b[col]) return 0
      })
    },
    refreshChecks: function () {
      if (this.selectedAll) {
        document.querySelector('#select-all').MaterialCheckbox.check()
      } else {
        document.querySelector('#select-all').MaterialCheckbox.uncheck()
      }
      var self = this
      this.filtered.forEach(function (row) {
        if (self.selected.indexOf(row.id) > -1) {
          document.querySelector('#select-' + row.id).MaterialCheckbox.check()
        } else {
          document.querySelector('#select-' + row.id).MaterialCheckbox.uncheck()
        }
      })
    },
    toggleShowEmail: function () {
      this.emailInputType = (this.isFaEye ? 'email' : 'password')
      this.hideText = !this.isFaEye
      this.isFaEye = !this.isFaEye
      this.isFaEyeSlash = !this.isFaEyeSlash
    }
  },
  watch: {
    'selected': {
      handler: function (val) {
        this.data.forEach(function (row) {
          row['__checked'] = val.indexOf(row.id) > -1
        })
        this.refreshChecks()
      },
      deep: true
    },
    'query': {
      handler: function (query) {
        this.filtered = this.data.filter(function (row) {
          var stays = true
          Object.keys(query).forEach(function (col) {
            var value = row[col] || ''
            var q = query[col] || ''
            if (value.toLowerCase().indexOf(q.toLowerCase()) === -1) {
              stays = false
            }
          })
          return stays
        })
      },
      deep: true
    },
    'data': {
      handler: function (newData, oldData) {
        this.filtered = newData
      },
      deep: true
    }
  },
  data: function () {
    return {
      sorted: {},
      selected: [],
      filtered: {},
      query: {},
      isFaEye: true,
      isFaEyeSlash: false,
      emailInputType: 'password',
      hideText: true
    }
  },
  computed: {
    selectedAll: function () {
      return this.selected.length === this.filtered.length
    }
  }
}
</script>

<style scoped>
.symbol {
  cursor: pointer;
}
.symbol .material-icons {
  font-size: 16px;
  vertical-align: middle;
  margin-bottom: 5px;
}
.symbol .filter-icon {
  margin-left:  -22px;
}
.column-check {
  width: 30px;
}
.full-width {
    width: 100%;
}
.filter-textfield {
  width: 100%;
  padding: 0;
}
.filter-textfield input {
  font-size: 12px;
  font-weight: 700;
}
.slot {
  margin-top: 16px;
}
.hidetext {
  -webkit-text-security: disc; /* Default */ 
}
</style>



// WEBPACK FOOTER //
// Table.vue?3e9bf368